export const promiseReject = (value) => {
    return Promise.reject(value);
}